module.exports = __webpack_public_path__ + "media/images/training_man-64d58963c614d216dd8edd328a39dd0e.png";